import SearchApi from "../Api/search-api";

let timers;

let searchResultsDropdown = document.querySelector('.js_results_dropdown');

const getSearchDropdown = () => {
    if (searchResultsDropdown) {
        return searchResultsDropdown.querySelector('.js_products');
    }
    return null;
};

const itemTemplate = item => `<a class="d-flex justify-content-between gap-10" 
                                href="${item.url}"
                               >
                                    <div class="fs-sm-14 fs-12">${item.title}</div>
                                    <div class="fs-12 fw-rg text-main">
                                        <span class="fs-sm-14 fs-12 fw-sb text-main text-end text-nowrap">${item.price}</span>
                                    </div>
                                </a>`;

const search = searchPhrase => {
    let searchDropdown = getSearchDropdown();
    if (searchDropdown) {
        searchDropdown.classList.add('preloader');
        searchDropdown.innerHTML = '';
        SearchApi.autocomplete(searchPhrase)
            .then(e => e.json())
            .then(e => {
                if (e.success) {
                    let message = `<a class="d-flex justify-content-between gap-10">По вашему запросу ничего не найдено</a>`;
                    if (e.data.length) {
                        message = '';
                        e.data.forEach(category => {
                            message += `<div class="header-search-result-group d-flex flex-column gap-10">
                                            <a class="fw-sb fs-sm-16 fs-14" href="${category.url}">
                                            ${category.title}
                                        </a>`;
                            category.childs.forEach(item => {
                                item.price = item.price > 0 ? item.price += ' ₽' : 'Цена по запросу';
                                message += itemTemplate(item);
                            })
                            message += `</div>`;
                        });
                    }

                    searchDropdown.innerHTML = message;
                    searchResultsDropdown.classList.add('active');
                }
            })
            .finally(() => searchDropdown.classList.remove('preloader'));
    }
};

const inputEvent = event => {
    if (searchResultsDropdown) {
        clearTimeout(timers);
        let searchPhrase = event.target.value || '';
        let searchLink = document.querySelector('.js_search_link');

        if (searchLink) {
            searchLink.href = '/search.html?stext=' + searchPhrase;
        }

        if (searchPhrase.trim().length > 1) {
            timers = setTimeout(search.bind(null, searchPhrase), 500);
        }
    }
};

const focusEvent = event => {
    if (searchResultsDropdown && event.target.value.trim().length) {
        searchResultsDropdown.classList.add('active');
    }
};

const blurEvent = () => {
    let searchDropdown = getSearchDropdown();
    if (searchDropdown) {
        setTimeout(() => searchResultsDropdown.classList.remove('active'), 200);
    }
};

const clickSearchButton = event => {
    const searchField = event.target.closest('form').querySelector('.search-field');
    if (searchField.value.length > 2) {
        window.location = "search.html?stext=" + searchField.value;
    }
};

const initEvents = () => {
    document.querySelectorAll('.search-field').forEach(item => {
        item.addEventListener('input', inputEvent);
        item.addEventListener('focus', focusEvent);
        item.addEventListener('blur', blurEvent);
    });

    document.querySelectorAll('.search-button')
        .forEach(item => item.addEventListener('click', clickSearchButton));
};

const clearEvents = () => {
    document.querySelectorAll('.search-field').forEach(item => {
        item.removeEventListener('input', inputEvent);
        item.removeEventListener('focus', focusEvent);
        item.removeEventListener('blur', blurEvent);
    });
    document.querySelectorAll('.search-button')
        .forEach(item => item.removeEventListener('click', clickSearchButton));
};

const Init = () => {
    clearEvents();
    initEvents();
};

export const searchAutocomplete = {
    'init': Init
};
